import { useState } from "react";
import { itemDropdownAcara } from "../../utils/publikasiUtils";
import Loading from "../../components/Loading";
import Pagination from "../../components/Pagination";
import Head from "next/head";
import Search from "../../components/publikasi/Search";
import Filter from "../../components/publikasi/Filter";
import ListAcara from "../../components/publikasi/ListAcara";
import useAcara from "../../service/publikasi/useAcara";
import {
  getEventsPublications,
  useEventsPublications,
} from "../../service/useEventsPublications";

export async function getServerSideProps(context) {
  const { query } = context;
  const { data, fetching, error } = await getEventsPublications({
    category: "acara",
    ...query,
    limit: 16,
  });

  if (error) {
    return {
      props: {
        data: null,
        total: 0,
        fetching: false,
      },
    };
  }

  const temps = [];
  for (const item of data.cms_events) {
    temps.push({
      id: item.id,
      title: item.title,
      location: item.location,
      created_at: item.created_at,
      picture: item.picture,
      time: item.time,
      url: item.url,
      description: item.description,
    });
  }

  const total = data.cms_events_aggregate.aggregate.count;

  return {
    props: {
      data: temps || null,
      total: total || 0,
      fetching: fetching || null,
    },
  };
}

const url = "/acara";

export default function Acara({ data, fetching, total }) {
  const {
    search,
    setSearch,
    handleChange,
    handleOrder,
    handlePage,
    open,
    setOpen,
    pages,
    selected,
  } = useEventsPublications({
    cat: "Acara",
  });

  const schemeData = {
    "@type": "Acara",
    data: data,
  };

  return (
    <main className="relative h-full w-full bg-[#F3F7FA]">
      <Head>
        <title>Acara | Wardaya Online by Wardaya College</title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemeData),
          }}
        />
      </Head>
      <div className="mx-auto flex w-full max-w-[1260px] flex-col items-center px-4 pt-24 md:pt-36">
        <h1 className="bg-gradient-to-tr from-[#024D88] to-[#006ABE] bg-clip-text text-center font-nunito text-2xl font-black text-transparent md:text-4xl">
          Acara
        </h1>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-2 md:flex-row md:gap-3">
          <Search
            search={search}
            handleChange={(e) => {
              setSearch(e.target.value);
              handleChange(url, "title", e.target.value);
            }}
          />
          <Filter
            itemDropdown={itemDropdownAcara}
            selected={selected}
            open={open}
            setOpen={setOpen}
            handleOrder={(e) => handleOrder(e, url)}
          />
        </div>

        <ul className="mt-8 grid w-full grid-cols-2 items-center justify-center justify-items-center gap-x-5 gap-y-7 px-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {data && data.length
            ? data.map((item, i) => (
                <ListAcara
                  key={item.id}
                  title={item.title}
                  picture={item.picture}
                  date={item.time.split("T")[0]}
                  time={item.time.split("T")[1].split("+")[0].split(".")[0]}
                  url={item.url}
                />
              ))
            : null}
        </ul>

        {data?.length ? (
          <div className="mt-16 mb-32">
            <Pagination
              total={total}
              currentPage={pages}
              getCurrent={(number) => handlePage(number, url)}
              pageSize={16}
              maxPages={5}
            />
          </div>
        ) : (
          <div className="flex w-full flex-col items-center justify-center gap-5">
            <img src="/images/404.svg" alt="error" className="h-72" />
            <p className="text-center font-nunito text-xl font-bold text-[#142D59]">
              Data tidak tersedia
            </p>
          </div>
        )}
      </div>

      {fetching ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}

      <img
        className="absolute right-0 bottom-64 hidden -scale-x-100 md:block"
        src="/images/paperplane.webp"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = "/images/paperplane.png";
        }}
        alt="paperplane"
      />
      <img
        className="absolute left-0 bottom-0 hidden md:block"
        src="/images/paperplane.webp"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = "/images/paperplane.png";
        }}
        alt="paperplane"
      />

      <style>
        {`
            p.hide-text {
              display: -webkit-box;
              max-width: 95%;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          `}
      </style>
    </main>
  );
}
